/**
 * Date formatting utilities using Lithuanian conventions.
 */

/**
 * Format a date string (ISO) to YYYY-MM-DD.
 */
export function formatDate(date: string | undefined | null): string {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Format a date string to a more readable Lithuanian format: YYYY-MM-DD.
 */
export function formatDateDisplay(date: string | undefined | null): string {
  return formatDate(date);
}

/**
 * Get today's date as YYYY-MM-DD string.
 */
export function today(): string {
  return formatDate(new Date().toISOString());
}

/**
 * Get a date N days ago as YYYY-MM-DD string.
 */
export function daysAgo(n: number): string {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return formatDate(d.toISOString());
}

/**
 * Get a date N months ago as YYYY-MM-DD string.
 */
export function monthsAgo(n: number): string {
  const d = new Date();
  d.setMonth(d.getMonth() - n);
  return formatDate(d.toISOString());
}

/**
 * Get a date N years ago as YYYY-MM-DD string.
 */
export function yearsAgo(n: number): string {
  const d = new Date();
  d.setFullYear(d.getFullYear() - n);
  return formatDate(d.toISOString());
}
